import { isPlainObject as _isPlainObject } from 'lodash';
import { readFile } from './read-file';
import getDataFromFile from './get-data-from-file';
import { detectUploadType, detectUploadTypeFromContent } from './UPLOAD_TYPE';

// Reads + parses the uploaded file and stores it as one { result, extension, type }
// object. Validation is run by the modal once the type is known, so it re-runs when
// the user overrides the detected type. The single object also keeps React 17's
// (un-batched) async state updates from triggering validation with a half-set state.
export async function selectFile({ event, uploadState, setUpload }) {
  const file = event.target.files[0];

  // file is undefined if the user cancels after opening the file selector
  if (!file) {
    uploadState.setError(null);
    setUpload(null);
    return;
  }

  const { name } = file;
  const extension = name.substring(name.lastIndexOf('.') + 1);

  try {
    const fileData = await readFile(file);
    const result = getDataFromFile(extension, fileData);
    // An empty file (yaml.load('') is undefined), a non-object scalar, or an
    // unsupported extension parses to something that isn't a config object. The
    // type isn't known yet, so preventUpload can't run — surface the error here
    // rather than leaving Apply silently disabled with no explanation.
    if (!_isPlainObject(result)) {
      uploadState.setError(
        `This file doesn't contain valid configuration. We only support JSON or YAML files that contain a playbook or connection.`
      );
      setUpload(null);
      return;
    }
    // Content is the authoritative signal; fall back to the file name when the
    // contents don't clearly indicate a type.
    setUpload({ result, extension, type: detectUploadTypeFromContent(result) ?? detectUploadType(name) });
  } catch (e) {
    // display error if the file cannot be parsed
    uploadState.setError(e.message);
    setUpload(null);
  }
}
